import styled from '@emotion/styled';
import { Button, Typography } from '@mgmresorts/mgm-ui';

import { convertFontWeight } from '../../../utils/vegaTokenHelpers';

export const StyledIDMeModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const StyledIDMeModal = styled.div`
  background: ${({ theme }) => theme.semantic.BgDefault};
  border-radius: ${({ theme }) => theme.semantic.BorderRadiusComponentXl}px;
  max-width: 512px;
  overflow-y: auto;
  position: relative;
  margin: ${({ theme }) => theme.semantic.SpaceComponentM}px;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    margin: 0;
    border-radius: 0;
  }
`;

export const StyledIDMeHeader = styled.div`
  padding: ${({ theme }) => theme.semantic.SpaceLayoutS}px;
  padding-right: ${({ theme }) => theme.semantic.SizeComponentXl};
`;

export const StyledIDMeTitle = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgDefault};
  margin: ${({ theme }) => theme.semantic.SpaceComponentNone}px;

  &:focus {
    outline: none;
  }
`;

export const StyledIDMeContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.semantic.SpaceComponentM}px;
  padding: 0 ${({ theme }) => theme.semantic.SpaceLayoutS}px;

  @media (max-width: 768px) {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
  }
`;

export const StyledIDMeDescription = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgDefault};
`;

export const StyledIDMeLegal = styled.div`
  color: ${({ theme }) => theme.semantic.FgContrast};
  max-width: 343px;

  p {
    margin: ${({ theme }) => theme.semantic.SpaceComponentNone}px;
    color: ${({ theme }) => theme.semantic.FgContrast};
    font-family: ${({ theme }) => theme.semantic.BodyRegularS.fontFamily};
    font-size: ${({ theme }) => theme.semantic.BodyRegularS.fontSize}px;
    font-weight: ${({ theme }) => convertFontWeight(theme.semantic.BodyRegularS.fontWeight)};
    line-height: ${({ theme }) => theme.semantic.BodyRegularS.lineHeight};
  }

  ul {
    margin: ${({ theme }) => theme.semantic.SpaceComponentNone}px;
    padding-left: 20px;
    list-style-position: outside;
  }

  li {
    list-style-type: disc;
    color: ${({ theme }) => theme.semantic.FgContrast};
    font-family: ${({ theme }) => theme.semantic.BodyRegularS.fontFamily};
    font-size: ${({ theme }) => theme.semantic.BodyRegularS.fontSize}px;
    font-weight: ${({ theme }) => convertFontWeight(theme.semantic.BodyRegularS.fontWeight)};
    line-height: ${({ theme }) => theme.semantic.BodyRegularS.lineHeight};
  }

  a {
    display: inline;
    color: ${({ theme }) => theme.semantic.FgContrast};

    &:hover,
    &:active,
    &:focus-visible {
      color: ${({ theme }) => theme.semantic.FgContrast};
    }
  }
`;

export const StyledIDMeFooter = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.semantic.SpaceComponentS}px;
  padding: ${({ theme }) => theme.semantic.SpaceLayoutS}px;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    align-items: stretch;
  }
`;

export const StyledIDMeFooterButton = styled(Button)`
  flex: 1;
  justify-content: center;

  @media (max-width: 768px) {
    flex: initial;
  }
`;

export const StyledIDMeCloseButton = styled.button`
  position: absolute;
  top: ${({ theme }) => theme.semantic.SpaceComponentM}px;
  right: ${({ theme }) => theme.semantic.SpaceComponentM}px;
  width: ${({ theme }) => theme.semantic.SizeComponentXl}px;
  height: ${({ theme }) => theme.semantic.SizeComponentXl}px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: ${({ theme }) => theme.semantic.FgContrast};

  &:hover {
    color: ${({ theme }) => theme.semantic.FgDefault};
  }
`;
